import img1 from '../images/team/team-01.jpg'
import img2 from '../images/team/team-02.jpg'
import img3 from '../images/team/team-03.jpg'
import img4 from '../images/team/team-04.jpg'
import img5 from '../images/team/team-05.jpg'
import img6 from '../images/team/team-06.jpg'
import img7 from '../images/team/team-07.jpg'
import img8 from '../images/team/team-08.jpg'
import img9 from '../images/team/team-09.jpg'
import img10 from '../images/team/team-10.jpg'
import img11 from '../images/team/team-11.jpg'
import img12 from '../images/team/team-12.jpg'

const dataTeam = [
    {
        img: img1,
        name:'DC PCSB',
        position: 'Video Production and Livestreaming'
    },
    {
        img: img2,
        name:'Willco',
        position: 'Architectural Photography'
    },
    {
        img: img3,
        name:'WineLAIR',
        position: 'Web Development'
    },
    {
        img: img4,
        name:'James Smith',
        position: 'Founder & CEO'
    },
    {
        img: img5,
        name:'Mike Anderson',
        position: 'Founder & CEO'
    },
    {
        img: img6,
        name:'Paul Harrison',
        position: 'Founder & CEO'
    },
    {
        img: img7,
        name:'Sarah Jenifer',
        position: 'Founder & CEO'
    },
    {
        img: img8,
        name:'James Smith',
        position: 'Founder & CEO'
    },
    {
        img: img9,
        name:'Paul Harrison',
        position: 'Founder & CEO'
    },
    {
        img: img10,
        name:'Sarah Jenifer',
        position: 'Founder & CEO'
    },
    {
        img: img11,
        name:'Mike Anderson',
        position: 'Founder & CEO'
    },
    {
        img: img12,
        name:'James Smith',
        position: 'Founder & CEO'
    },
]

export default dataTeam;